<template>
  <div class="bg-white border border-gray-400 rounded-md dark:bg-slate-900 dark:border-gray-700 mb-3 overflow-hidden">
    <div class="flex justify-between items-center px-6 pt-4">
      <div class="flex-1">
        <h2 v-if="title" class="text-lg font-bold text-gray-800 dark:text-white flex items-center">
          <UserCircleIcon class="size-6 mr-2 text-blue-600 dark:text-blue-500" />
          {{ title }}
        </h2>
      </div>
      <div class="flex gap-3">
        <slot name="before-buttons"></slot>
        <ButtonTeleporter>
              <slot name="buttons"></slot>
              <div v-if="showDocumentos">
                <div v-if="technologia">
                    <template v-if="technologia.contratoxservicio && cambiarDocumentos">
                      <ButtonDefault class="mb-1" color="blue" @click="openModal('offset-consentimientos', { onlyOne: false, component: ModalDocumentos, props: { parametros, setDatosPaciente, technologia, origen: 'ATENCION' }})">
                        <DocumentCheckIcon class="shrink-0 w-4 h-4" />
                        <span class="xs:hidden lg:block">Documentos</span>
                      </ButtonDefault>
                    </template>
                </div>
              </div>
              <div v-if="showGraficas && admision && admision?.paciente">
                <ButtonDefault  type="button" @click="openModal('offset-graficas', { component: ModalPatientGraficas, props: { persona: admision?.paciente, technologias: admision?.technologias }, onlyOne: false})">
                  <MdiIcon icono="mdiChartBar" />
                  <span class="xs:hidden lg:block">Graficas</span>
                </ButtonDefault>
              </div>
              <div v-if="showHistorial && admision && admision?.technologias && admision?.paciente">
                <ButtonDefault  type="button" @click="openModal('offset-historicos', { component: ModalHistorialInfo, props: { persona: admision?.paciente, technologias: admision?.technologias }, onlyOne: false})">
                  <MdiIcon icono="mdiHistory" />
                  <span class="xs:hidden lg:block">Historicos</span>
                </ButtonDefault>
              </div>
        </ButtonTeleporter>
      </div>
    </div>
    <div class="pb-6 px-5">
      <div class="flex justify-center">
        <div class="grid grid-cols-12 gap-6 max-w-7xl w-full">
          <div class="col-span-3">
            <div class="flex flex-col items-center text-center">
            <span
              class="inline-flex items-center justify-center size-16 rounded-full bg-linear-to-r from-blue-600 to-blue-500 text-xl font-bold text-white mb-3">
              {{
                getIniciales(
                  patientInfo.data?.copnNombre1 as string,
                  patientInfo.data?.copnApellido1
                )
              }}
            </span>
            <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
              {{ patientInfo.data?.copeShortName }}
            </h2>
            <span
              v-if="patientInfo.empresaNombre"
              class="px-2 py-1 mb-3 inline-flex items-center rounded-md text-xs font-medium bg-blue-50 text-blue-800 border border-blue-100 dark:bg-blue-900/30 dark:text-blue-400 dark:border-blue-800/60">
              {{ patientInfo.empresaNombre }}
            </span>
            <div
              class="w-full px-3 py-1 bg-gray-50 rounded-lg border border-gray-100 dark:bg-gray-800/50 dark:border-gray-700/30">
              <div class="flex xs:justify-between md:flex-col lg:justify-between items-center mb-2">
                <p class="text-xs text-gray-500 dark:text-gray-400">Régimen:</p>
                <p class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ patientInfo.regimenNombre }}
                </p>
              </div>
              <div class="flex xs:justify-between md:flex-col lg:justify-between items-center">
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  Documento:
                </p>
                <span class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ patientInfo.tipoDocumentoNombre }}
                  {{ patientInfo.documentoNumero }}
                </span>
              </div>
            </div>
            </div>
          </div>
          <div class="col-span-9 mt-3">
            <div
              class="p-4 mx-auto py-7  bg-gray-50 rounded-lg border border-gray-100 dark:bg-gray-800/50 dark:border-gray-700/30">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <!-- Información Personal -->
                <div class="flex flex-col">
                  <div class="flex items-center mb-4">
                    <UserIcon class="size-5 text-blue-600 dark:text-blue-500 mr-2" />
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                      Información Personal
                    </h3>
                  </div>
                  <ul class="space-y-3.5 w-full">
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiCake"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-20">Edad:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{
                          calcularEdad(patientInfo.data?.coppFechanacimiento as string, technologia?.cittFechaInicio?.split('T')[0])
                        }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiCalendar"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-20">Nacimiento:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{  patientInfo.data?.coppFechanacimiento }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon
                        type="mdi" class="size-4 text-gray-500 mr-3" :path="patientInfo.data?.sexo?.comaNombrecorto == 'F'
                          ? mdiGenderFemale
                          : mdiGenderMale
                        "></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-20">Género:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ patientInfo.data?.sexo?.comaNombrelargo }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiAccountGroup"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-20">Población:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{
                          patientInfo.data?.poblacion?.comaNombrecorto ||
                          '(No registrada)'
                        }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiHuman"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-20">Orientación:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{
                          patientInfo.data?.orientacion?.comaNombrelargo ||
                          '(No registrada)'
                        }}
                      </span>
                    </li>
                  </ul>
                </div>

                <!-- Ubicación y Contacto -->
                <div class="flex flex-col">
                  <div class="flex items-center mb-4">
                    <MapPinIcon class="size-5 text-blue-600 dark:text-blue-500 mr-2" />
                    <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                      Ubicación y Contacto
                    </h3>
                  </div>
                  <ul class="space-y-3.5 w-full">
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiHome"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Dirección:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white  max-w-50">
                        {{
                          patientInfo.data?.copeDireccion?.trim() || '(Sin dirección)'
                        }}{{ patientInfo.data?.coppTipoBarrio?.trim() ? ', ' + patientInfo.data?.coppTipoBarrio?.trim() : '' }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiPhone"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Teléfono:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ patientInfo.data?.copeTelefono || '(Sin teléfono)' }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiCity"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Ciudad:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{
                          patientInfo.data?.divipola?.nomMunicipio ||
                          '(No registrada)'
                        }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiMap"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Departamento:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{
                          patientInfo.data?.divipola?.nomDepartamento ||
                          '(No registrado)'
                        }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiCalendar"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Fecha de admisión:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ formatearFechaEnEspanol(props.admision?.ciadFechaOrigen ??'') }}
                      </span>
                    </li>
                    <li class="flex items-center">
                      <svg-icon type="mdi" class="size-4 text-gray-500 mr-3" :path="mdiCalendar"></svg-icon>
                      <span class="text-xs text-gray-500 dark:text-gray-400 w-24">Fecha de inicio de la atencion:</span>
                      <span class="text-sm font-medium text-gray-900 dark:text-white">
                        {{ formatearFechaEnEspanol(technologia?.cittFechaInicio ??'') }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <OrigenAtencion
        v-if="showOrigen && technologia?.cittId"
        :citt-id="technologia.cittId"
        class="py-1 mt-2 border-t border-gray-400 dark:border-gray-700"
        @cargado="emit('origenCargado', $event)"
      />

      <slot name="content-middle"></slot>
      <div v-if="showTechnologias" class="py-1 mt-2 border-t border-gray-400 dark:border-gray-700">
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center">
            <svg-icon type="mdi" :path="mdiHospitalBox" class="size-5 text-blue-600 dark:text-blue-500 mr-2" />
            <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Servicios y cups</h3>
          </div>
        </div>
        <div v-if="props.admision?.technologias && props.admision.technologias.length > 0" class="grid xs:grid-cols-1 lg:grid-cols-2 gap-2">
          <div
              v-for="(tecnologia, index) in props.admision.technologias"
              :key="index"
              class="flex items-center p-1.5 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/50">
            <div class="flex-1 min-w-0">
              <p class="text-xs font-bold text-blue-900 dark:text-blue-100 uppercase">
                {{ tecnologia.contratoxservicio?.servicio?.coseNombre || '(Sin tecnología)' }}
              </p>
              <p class="text-xs font-medium text-blue-900 dark:text-blue-100 uppercase">
                {{ tecnologia.cittCodTechnologia || '(Sin código)' }}. {{ tecnologia.cittTechnologia || '(Sin tecnología)' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showAlerts && patientInfo.data?.copeId"
        class="mt-4 pt-3 border-t border-gray-400 dark:border-gray-700">
        <ViewAlerts :copp-id="patientInfo.data.copeId" :is-mini="true" :show-add-button="showAlertButton" :show-close-button="true" :citt-id-context="technologia?.cittId" />
      </div>

      <slot name="after-content"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue'
import {
  UserIcon,
  MapPinIcon,
  UserCircleIcon,
  DocumentCheckIcon
} from '@heroicons/vue/24/outline'
import {
  mdiGenderMale,
  mdiGenderFemale,
  mdiCake,
  mdiPhone,
  mdiHome,
  mdiCity,
  mdiAccountGroup,
  mdiMap,
  mdiHuman,
  mdiHospitalBox,
  mdiCalendar
} from '@mdi/js'
import {
  getIniciales,
  calcularEdad,
  formatearFechaEnEspanol
} from '@/modules/Core/usings/generales.js'
import type { ICitaAdmision } from '@/modules/Admision/interfaces'
import { mergePacienteSnapshot } from '@/modules/Core/usings/pacienteSnapshot'
import ViewAlerts from '@/modules/Administracion/components/ViewAlerts.vue'

import MdiIcon from '../general/MdiIcon.vue'
import type { IConfDocjsonparametros } from '@/modules/Configuracion/interfaces'
import type { IDocumentoFirma } from '@/modules/Configuracion/interfaces/IDocumento'
import { useModal } from '../../composables/useModal'
import ModalHistorialInfo from '@/modules/Asistencial/components/ModalHistorialInfo.vue'
import OrigenAtencion from '@/modules/Asistencial/components/OrigenAtencion.vue'
import type { IOrigenAtencion } from '@/modules/Asistencial/interfaces/IOrigenAtencion'
import ModalPatientGraficas from '@/modules/Asistencial/components/ModalPatientGraficas.vue'
import ModalDocumentos from '@/modules/Asistencial/components/ModalDocumentos.vue'
const { openModal } = useModal()
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  admision: {
    type: Object as () => ICitaAdmision,
    default: null
  },
  paciente: {
    type: Object,
    default: null
  },
  cittId: {
    type: [Number, String],
    default: null
  },
  showAlertButton: {
    type: Boolean,
    default: false
  },
  showAlerts: {
    type: Boolean,
    default: true
  },
  showHistorial: {
    type: Boolean,
    default: false
  },
  showTechnologias: {
    type: Boolean,
    default: false
  },
  showGraficas: {
    type: Boolean,
    default: false
  },
  showDocumentos: {
    type: Boolean,
    default: false
  },
  showOrigen: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits<{
  origenCargado: [origen: IOrigenAtencion | null]
}>()
const cambiarDocumentos = ref<boolean | null>(null)
const parametros = ref<IConfDocjsonparametros[]>([])
// La atención en contexto define el snapshot del paciente; sin cittId se cae a la primera.
const technologia = computed(() => {
  const technologias = props.admision?.technologias
  if (!technologias || technologias.length === 0) return null
  if (props.cittId) {
    const enContexto = technologias.find(item => item.cittId == props.cittId)
    if (enContexto) return enContexto
  }
  return technologias[0]
})
const patientInfo = computed(() => {
  const pacienteData = mergePacienteSnapshot(props.paciente || props.admision?.paciente, technologia.value)
  return {
    data: pacienteData,
    empresaNombre: props.admision?.contrato?.empresa?.coemNombre || '',
    regimenNombre: props.admision?.contrato?.tiporegimen?.comaNombrelargo || '',
    tipoDocumentoNombre: pacienteData?.tipoidentificacion?.comaNombrecorto || '',
    documentoNumero: pacienteData?.copeIdentificacion || ''
  }
})
const setDatosPaciente = async (firma: IDocumentoFirma) => {
    firma.nombre =  patientInfo.value.data.copeFullName as string
    firma.identificacion = `${patientInfo.value.data.tipoidentificacion?.comaNombrecorto} ${patientInfo.value.data.copeIdentificacion}`
}
onMounted(async () => {
  cambiarDocumentos.value = false
  await nextTick()
  parametros.value = [
    {
      cdjpNombre: 'P_COPE_ID',
      valor: patientInfo.value.data.copeId
    }
  ] as IConfDocjsonparametros[]
  await nextTick()
  cambiarDocumentos.value = true
})
</script>
